import mitt from 'mitt';
import { EventName } from '@/constants';
import { OrderItem } from '@/models/order';

type Events = {
    [EventName.OrderAdded]: OrderItem;
    [EventName.OrderChanged]: OrderItem;
    [EventName.PageReload]: { page: string } | undefined;
    [EventName.BetsChanged]: { customEventIds: string[]; betIds: string[] };
    [EventName.BrowserTabVisibilityChanged]: { isBrowserTabInactive: boolean; browserTabInactiveTimeSec?: number };
    [EventName.LanguageChanged]: string;
    [EventName.PageResize]: void;
};

const eventBus = mitt<Events>();

export default eventBus;
